import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('Error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h2>⚠️ Backend Services Not Running</h2>
          <p>Please start the required services:</p>
          <pre style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', textAlign: 'left', maxWidth: '600px', margin: '20px auto' }}>
            cd product-service && mvn spring-boot:run
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
